import {
	SEARCH_SUGGESTIONS_REQUEST,
	SEARCH_SUGGESTIONS_SUCCESS,
	SEARCH_SUGGESTIONS_FAIL,
	CLEAR_SEARCH_SUGGESTIONS,
} from '../actions/index';
interface SearchState {
	loading: boolean;
	suggestions: any[];
	error: string | null;
}

const initialState: SearchState = {
	loading: false,
	suggestions: [],
	error: null,
};

const searchReducer = (state = initialState, action: any): SearchState => {
	switch (action.type) {
		case SEARCH_SUGGESTIONS_REQUEST:
			return { ...state, loading: true, error: null };
		case SEARCH_SUGGESTIONS_SUCCESS:
			return { ...state, loading: false, suggestions: action.payload };
		case SEARCH_SUGGESTIONS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
				suggestions: [],
			};
		case CLEAR_SEARCH_SUGGESTIONS:
			return {
				...state,
				loading: false,
				suggestions: [],
				error: null,
			};
		default:
			return state;
	}
};
export default searchReducer;
